import { ImportStagingController } from "../../../controllers";
import { ComponentBase } from "../../_ComponentBase";

/**
 * Provides an UI to the import staging area if one is available for the current company..
 */
export class ImportStaging extends ComponentBase {
  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
    /** Binds the current payroll (the full object) typically from the Payroll details view. */
    payroll: "<",

    /** If the list off calculations committed into the Payroll typically from the Payroll details view. */
    payrollCalcs: "<",
  };

  /** Uses the ImportStagingController */
  public controller = ImportStagingController;

  /** The default template for the component. */
  public defaultTemplate = "salaxy-components/helpers/import/staging/ImportStaging.html";
}
